import React from 'react';

export const Desktop: React.FC<React.PropsWithChildren> = ({children}) => {
    return (
        <div className="max-tablet:hidden">{children}</div>
    )
}
